module.exports = __webpack_public_path__ + "img/flip3.b901c7d4.png";